import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Container,
  Card,
  Stack,
  Typography
} from '@mui/material';
import Grid from "@mui/material/Grid2";

import { Logo } from "@/assets/logos";
import { MenuCard } from "@/components/cards";
import { options, extraOptions } from "@/options";
import { useAuth0 } from '@auth0/auth0-react';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth0();

  const checkPermission = (permission: string): boolean => {
    if (!user) {
      return false
    } else {
      return user[`https://${process.env.REACT_APP_AUTH0_DOMAIN}/permissions`].includes(permission);
    }
  }

  console.log(user);

  return (
    <Container>
      <Grid
        container
        spacing={2}
        display="flex"
        flexGrow={1}
        justifyContent="center"
        alignContent="center"
      >
        <Grid size={12} display="flex" justifyContent="center">
          <Box width="50%">
            <Logo />
          </Box>
        </Grid>
        {options.map((option, index) => (
          <Grid key={index}>
            <MenuCard option={option} disabled={!checkPermission(option.permission)} />
          </Grid>
        ))}
        {extraOptions.map((option, index) => {
          if (checkPermission(option.permission)) {
            return (
              <Grid key={index}>
                <MenuCard option={option} disabled={false}/>
              </Grid>
            )}
        })}
      </Grid>
    </Container>
  )

}

export default HomePage;
